import { CpOrderInvoicesSearchModel } from './cp_order_invoices_search_types';

export function cleanCpOrderInvoicesSearchPayload(state: CpOrderInvoicesSearchModel): any {
    // Transform or sanitize the state as needed before sending to API
    // For now, just flatten the structure for API compatibility
    const cleanedState: CpOrderInvoicesSearchModel = {
        ...state,
        ProgramAdmin: {
            ...state.ProgramAdmin,
            val: state.ProgramAdmin.val === 'N/A' ? '' : state.ProgramAdmin.val,
        },
        CE: {
            ...state.CE,
            val: state.CE.val === 'N/A' ? '' : state.CE.val,
        },
    };

    return cleanedState;
}
